export default function Description({
	descriptionParagraph1,
	descritionParagraph2,
}: {
	descriptionParagraph1: string;
	descritionParagraph2: string;
}) {
	return (
		<div
			className={`
                        z-2 
                        hero-description-font-size
                        font-medium
                        leading-tight sm:leading-snug md:leading-normal
                    `}
		>
			<h2 className="text-balance">{descriptionParagraph1}</h2>
			<h2 className="hidden sm:block text-balance">
				{descritionParagraph2}
			</h2>
		</div>
	);
}